﻿import React, {Component} from 'react';
import { browserHistory } from 'react-router'
import { connect } from 'react-redux';
import {AgGridReact} from 'ag-grid-react';
import service from '../../services/template-services';

class TemplatesList extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleResize = this.handleResize.bind(this);

        let tableHeight = this.getTableHeight();
        this.state = {
            tableHeight
        };

        this.gridOptions = null;
    }

    componentDidMount() {
        let self = this;

        this.props.onGetTemplates();
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        let self = this;
        this.props.onUnload();
        window.removeEventListener('resize', this.handleResize);
    }

    getTableHeight(){
        return window.innerHeight - 64/*header*/ - 20;
    }

    handleResize(e) {
        setTimeout(() => {
            let tableHeight = this.getTableHeight();
            this.setState({tableHeight: tableHeight});

            if(this.gridOptions) {
                this.gridOptions.api.sizeColumnsToFit();
            }

        }, 200);
    }

    onGridReady(options) {
        console.log(options);
        this.gridOptions = options;
        this.setGridData();
    }

    setGridData() {
        if(this.gridOptions && this.props && this.props.dataList){
            this.gridOptions.api.setRowData(this.props.dataList);
        }

        setTimeout(() => {
            if(this.gridOptions) {
                this.gridOptions.api.sizeColumnsToFit();
            }
        }, 200);
    }

    columnsDefinitions() {
        let columnDefs = [
            {
                headerName: "Id",
                field: "Id",
                headerTooltip: "Id",
                width: 60,
            },
            {
                headerName: 'Name',
                /*width: 300,*/
                headerTooltip: "Name",
                field: "Name",
                cellStyle: {paddingTop: 0, textAlign: "left"}
            }

        ];
        return columnDefs;
    }

    onRowSelected() {
        var selectedRow = this.gridOptions.api.getSelectedRows()[0];

        if(selectedRow){
            browserHistory.push(`/template/${selectedRow.Id}`);
        }
    }

    render() {
        console.log('render templates list');
        const { roles } = this.props;
        this.setGridData();
        return (
            <div ref="mainComponent" className="ag-material" style={{width: "100%", margin: "auto", height: this.state.tableHeight + "px"}}>
                <AgGridReact
                    colWidth={120}
                    minColWidth={50}
                    onGridReady={this.onGridReady.bind(this)}
                    columnDefs={this.columnsDefinitions()}
                    onSelectionChanged={this.onRowSelected.bind(this)}
                    rowSelection="single"
                    enableSorting="true"
                    enableFilter="true"
                    enableColResize="true"
                />
            </div>
        );
    }
}

TemplatesList.contextTypes = {
    router: React.PropTypes.any.isRequired
};

const mapStateToProps = state => ({...state.templates});

const mapDispatchToProps = dispatch => ({
    onGetTemplates: () =>
        dispatch({type: 'REQUEST_TEMPLATES', payload: service.TemplateServices.getTemplates()}),
    onUnload: () =>
        dispatch({type: 'TEMPLATES_PAGE_UNLOADED'})
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplatesList);